import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d8a2dff"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { for: "user_name" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { for: "user_email" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { for: "message" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  id: "send-container",
  class: "text"
}
const _hoisted_12 = {
  type: "submit",
  class: "submit-button"
}
const _hoisted_13 = {
  id: "send-return",
  class: "text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "contact",
      ref: "resizeElement",
      class: _normalizeClass({ light: !_ctx.darkMode, hasScrollBar: _ctx.hasScrollBar })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["title title2", { light: !_ctx.darkMode }])
      }, _toDisplayString(_ctx.$t("contact.title")), 3),
      _createElementVNode("div", {
        class: "text",
        innerHTML: _ctx.$t('contact.textMe')
      }, null, 8, _hoisted_1),
      _createElementVNode("form", {
        ref: "form",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("contact.name")) + ":", 1),
          _createElementVNode("input", {
            type: "text",
            class: "text",
            name: "user_name",
            id: "name",
            placeholder: _ctx.$t('contact.PHname'),
            required: ""
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("contact.email")) + ":", 1),
          _createElementVNode("input", {
            type: "email",
            class: "text",
            name: "user_email",
            id: "email",
            placeholder: _ctx.$t('contact.PHemail'),
            required: ""
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("contact.message")) + ":", 1),
          _createElementVNode("textarea", {
            id: "message",
            class: "text",
            name: "message",
            placeholder: _ctx.$t('contact.PHmessage'),
            rows: "5",
            required: ""
          }, null, 8, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", _hoisted_12, _toDisplayString(_ctx.$t("contact.send")), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.sendReturn ? _ctx.$t("contact." + _ctx.sendReturn) : "" + _ctx.error), 1)
        ])
      ], 544)
    ], 2),
    _createElementVNode("div", {
      id: "contact-list",
      class: _normalizeClass({ light: !_ctx.darkMode })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["contact text", { light: !_ctx.darkMode }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLink('https://www.linkedin.com/in/armand-chavy/')))
      }, " LinkedIn ", 2),
      _createElementVNode("a", {
        id: "email-link",
        class: _normalizeClass(["contact text", { light: !_ctx.darkMode }]),
        href: "mailto:achavy44@gmail.com"
      }, "Email", 2),
      _createElementVNode("div", {
        id: "resume",
        class: _normalizeClass(["contact text", { light: !_ctx.darkMode }]),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPDF && _ctx.openPDF(...args)))
      }, _toDisplayString(_ctx.$t("home.resume")), 3)
    ], 2)
  ], 64))
}